import { EXTENSION_STORE_URL } from '../utils/extensionPrompt'

interface Props {
  /** The ✕ — hide it now and stop asking. */
  onDismiss: () => void
  /** The store link was followed — stop asking, but stay mounted (see below). */
  onAcknowledge: () => void
}

/**
 * Dismissible bar offering the browser extension. Shown only to visitors who
 * demonstrably do not have it — see useExtensionPrompt for the rate limit.
 */
export default function ExtensionBanner({ onDismiss, onAcknowledge }: Props) {
  return (
    <div className="extension-banner" role="region" aria-label="Browser extension">
      {/* The same mark the extension itself ships as its toolbar icon, so the
          thing being offered here is recognizable once installed. Decorative —
          alt="" because the headline directly beside it already names it. */}
      <img className="extension-banner-icon" src="/favicon.svg" alt="" width={40} height={40} />
      <div className="extension-banner-body">
        <p className="extension-banner-title">Get the Eizel browser extension</p>
        <p className="extension-banner-text">
          Add the Eizel button to your browser to save any page instantly
        </p>
      </div>
      <a
        className="btn-primary extension-banner-cta"
        href={EXTENSION_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        // Going to the store is an answer, so record it — but do NOT hide the
        // banner here. Unmounting this anchor inside its own click handler can
        // cancel the target="_blank" navigation. It goes away on next load.
        onClick={onAcknowledge}
      >
        Get the extension
      </a>
      <button
        type="button"
        className="btn-ghost extension-banner-close"
        onClick={onDismiss}
        aria-label="Dismiss"
        title="Dismiss"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
          aria-hidden="true"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  )
}
